import { useFormContext } from "react-hook-form";
import RadioButtons from "@medoma/components/RadioButton/RadioButtons";
import RadioButton from "@medoma/components/RadioButton/RadioButton";
import { useWards } from "@/api/Patients";
import { Loading } from "@medoma/components/Loading/Loading";
import ErrorMessage from "@medoma/components/ErrorMessage/ErrorMessage";
import { useLingui } from "@lingui/react/macro";
import { deducedError } from "@/Utils/ErrorUtils";

export type WardInputFields = {
  wardId: string;
};

const WardInput = () => {
  const {
    register,
    formState: { errors },
  } = useFormContext<WardInputFields>();

  const { t } = useLingui();

  const {
    data: availableWards,
    isPending: isPendingWards,
    isError: isErrorWards,
    error: errorWards,
  } = useWards();

  if (isPendingWards) {
    return <Loading message={t`Hämtar lista med avdelningar`} />;
  }

  if (isErrorWards) {
    return (
      <ErrorMessage
        message={`${t`Kunde inte hämta lista med avdelningar.`} ${deducedError(errorWards)}`}
      />
    );
  }

  const wardIdOptions = {
    required: {
      value: true,
      message: t`Ange en avdelning för patienten`,
    },
  };

  // If there is only one ward, return a hidden input with the value.
  if (availableWards.length === 1 && availableWards[0]) {
    return (
      <input
        type="hidden"
        value={availableWards[0].id.toString()}
        {...register("wardId", wardIdOptions)}
      />
    );
  }

  return (
    <RadioButtons errorMessage={errors.wardId?.message} legend={t`Avdelning`}>
      {availableWards.length === 0 ? (
        <ErrorMessage
          message={t`Inga avdelningar hittades. Försök igen om en liten stund. Kontakta support om problemet kvarstår.`}
        />
      ) : (
        availableWards.map((ward) => (
          <RadioButton
            label={{ text: ward.displayName }}
            value={ward.id.toString()}
            key={ward.id}
            {...register("wardId", wardIdOptions)}
          />
        ))
      )}
    </RadioButtons>
  );
};

export default WardInput;
